import React from 'react'
import './ModernLoader.css'

export function ModernLoader({size = 64}) {
    const style = {width: size, height: size}
    return (
        <div className="modern-loader" style={style}>
            <div></div>
            <div></div>
            <div></div>
            <div></div>
        </div>
    )
}

export function LoaderOverlay() {
    return (
        <div className="loader-overlay">
            <ModernLoader/>
        </div>
    )
}

export default ModernLoader
